(function () {
  /**
   * @ngdoc module
   * @name binky.core.organizations.market-subsegments
   * @description defines organization market subsegment constants
   */
  angular.module('binky.core.organizations.market-subsegments', []);
})();
